
import Vue, {PropOptions} from 'vue';
import ShopCategoryChooser from '~/components/page-components/ShopCategoryChooser.vue';
import ShopGrid from '~/components/page-components/ShopGrid.vue';
import {shopsStore} from '~/lib/accessors/store-accessor';
import {ShopCategory} from '~/lib/api/types/ShopCategory';
import ChildView from '~/lib/types/ChildView';
import {castToVue} from '~/lib/util/util';


export default Vue.extend({
  components: {ShopGrid, ShopCategoryChooser},
  props: {
    // If child is undefined then we need to choose a child before redirecting to the shop.
    child: {
      type: Object,
      required: false,
    } as PropOptions<ChildView | undefined>,
  },
  data() {
    return {
      // fetchPage: emptyFetchPage(48)
      shopGridStyle: '',
    }
  },
  beforeMount() {
    shopsStore.initializeShopStore({
      errorCatcher: {
        vm: () => undefined,
      },
      fetchPage: undefined,
    });
  },
  beforeDestroy() {
    shopsStore.clear();
  },
  mounted() {
    console.log('ShopPicker mounted')
  },
  // computed: {
  //   shopStoreCategories() {
  //     return shopsStore.categories;
  //   },
  // },
  // watch: {
  //   shopStoreCategories() {
  //     console.log('shopStoreCategories', this.shopStoreCategories.length)
  //     this.setMaxHeight();
  //   }
  // },
  methods: {
    loadMore() {
      shopsStore.getNextPage()
    },
    search(searchText: string) {
      shopsStore.search(searchText);
    },
    selectCategory(category: ShopCategory) {
      shopsStore.searchShopCategory(category)
    },
    setMaxHeight() {
      this.$nextTick(() => {
        const h = castToVue(this.$refs.shopCategoryChooser)?.$el.clientHeight
        castToVue(this.$refs.shopGrid)!.$emit('setMaxHeight', h);
      })
    },
  },
})
